import { motion } from 'framer-motion';

interface TagChipsProps {
  tags: string[];
  activeTag: string | null;
  onTagPress: (tag: string) => void;
  onClear?: () => void;
}

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: '8px',
    marginBottom: '16px',
  },
  chip: {
    padding: '8px 16px',
    borderRadius: '9999px',
    fontSize: '13px',
    fontWeight: 600,
    border: '1px solid rgba(59, 130, 246, 0.3)',
    background: 'rgba(59, 130, 246, 0.15)',
    color: '#60a5fa',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'all 0.2s ease',
  },
};

export default function TagChips({ tags, activeTag, onTagPress, onClear }: TagChipsProps) {
  return (
    <div style={styles.container}>
      {tags.map((tag, index) => {
        const isActive = activeTag === tag;
        const displayTag = tag.startsWith('#') ? tag : `#${tag}`;
        
        return (
          <motion.button
            key={tag}
            style={{
              ...styles.chip,
              ...(isActive
                ? {
                    background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                    borderColor: 'transparent',
                    color: '#ffffff',
                    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.35)',
                  }
                : {}),
            }}
            onClick={() => isActive ? onClear?.() : onTagPress(tag)}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            whileHover={{
              scale: 1.05,
              y: -2,
              ...(isActive
                ? { background: 'linear-gradient(135deg, #3b82f6, #2563eb)', color: '#ffffff' }
                : { background: 'rgba(59, 130, 246, 0.25)', color: '#93c5fd', borderColor: 'rgba(96, 165, 250, 0.5)' }),
            }}
            whileTap={{ scale: 0.95 }}
            transition={{
              duration: 0.2,
              delay: index * 0.03,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {displayTag}
          </motion.button>
        );
      })}
    </div>
  );
}
